import {
  ErrorsFields,
  FormState,
  OptInOptions,
} from '@/core/interfaces/common';

import { CustomContactFields } from '@/features/NewForm/TakeActionFormContainerRedux/CustomContactFields';

import { hasAnyError } from '@/utils/helpers';

import {
  GeneralErrorMessage,
  SendButton,
  SubmitSection,
} from '@/themes/globalStyles';

import { ContactFieldsContainer } from '../ContactFieldsContainer';
import { OptCheckboxes } from '../OptCheckboxesSecunda';

interface SignupFormContainerProps {
  backgroundColor: string;
  buttonColor: string;
  submitButtonText: string;
  error: ErrorsFields;
  formState: FormState;
  isPending: boolean;
  optIn: OptInOptions;
  organizationName: string;
  textColor: string;
  setError: React.Dispatch<React.SetStateAction<ErrorsFields>>;
  setFormState: React.Dispatch<React.SetStateAction<FormState>>;
  ariaLabels?: {
    prefix?: string;
    firstName?: string;
    lastName?: string;
    streetAddress?: string;
    zipCode?: string;
    email?: string;
    phoneNumber?: string;
    customFields?: { [uuid: string]: string };
  };
}

export const SignupFormContainerRedux = ({
  backgroundColor,
  buttonColor,
  isPending,
  error,
  formState,
  optIn,
  organizationName,
  setError,
  setFormState,
  textColor,
  submitButtonText,
  ariaLabels,
}: SignupFormContainerProps) => {
  const handleOptChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      checked,
    } = event.target;

    setFormState(prevValues => ({
      ...prevValues,
      [name]: checked,
    }));
  };

  return (
    <>
      <ContactFieldsContainer
        ariaLabels={ariaLabels}
        backgroundColor={backgroundColor}
        error={error}
        formState={formState}
        requiredFields={{
          email: true,
          firstName: true,
          lastName: true,
        }}
        setError={setError}
        setFormState={setFormState}
        textColor={textColor}
        CustomContactFieldsComponent={CustomContactFields}
      />
      <SubmitSection>
        <SendButton
          aria-label={submitButtonText}
          backgroundcolor={buttonColor}
          className="muster-button"
          disabled={isPending}
          textcolor={textColor}
          type="submit"
          value={submitButtonText}
        />
        {hasAnyError(error) && (
          <GeneralErrorMessage role="alert">Please see errors above</GeneralErrorMessage>
        )}
      </SubmitSection>
      <OptCheckboxes
        isOptInEmail={formState.isOptInEmail}
        isOptInText={formState.isOptInText}
        backgroundColor={buttonColor}
        handleOptChange={handleOptChange}
        optIn={optIn}
        organizationName={organizationName}
      />
    </>
  );
};
